import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/copy';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  variant?: 'gold' | 'terracotta';
  className?: string;
}
const variants = {
  gold: 'bg-gold text-ink hover:bg-gold-ink hover:text-ivory shadow-[0_18px_36px_-20px_rgba(201,138,30,0.9)] focus-visible:outline-gold-ink',
  terracotta: 'bg-terracotta text-ivory hover:bg-ink shadow-[0_18px_36px_-20px_rgba(183,90,60,0.9)] focus-visible:outline-terracotta'
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  variant = 'gold',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-9 py-5 text-[15px]' : 'px-7 py-4 text-[13px] sm:text-sm';
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 rounded-full font-sans font-semibold uppercase tracking-[0.12em] transition-[background-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${variants[variant]} ${sizing} ${className}`} data-id="element-69" data-mp="19ajth9ot0dzu">
      <span data-id="element-70" data-mp="3exb4fq4r7qh6">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2} aria-hidden="true" data-id="element-71" data-mp="3ex2qrw0t4h4x" />
    </a>;
}